module.exports = __webpack_public_path__ + "static/Pt05-removebg-preview-526ceaa1092ee157bea22983727b19e5.png";